import type { ButtonHTMLAttributes, ReactNode } from 'react'
import styles from './Button.module.css'

export type ButtonVariant = 'primary' | 'secondary' | 'link'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Визуальный вариант кнопки */
  variant?: ButtonVariant
  /** Растянуть на всю ширину */
  block?: boolean
  children: ReactNode
}

/**
 * Базовая кнопка приложения.
 * @param variant - Вариант: primary | secondary | link
 * @param block - Растянуть на 100% ширины
 * @param children - Содержимое кнопки
 */
export const Button = ({
  variant = 'primary',
  block = false,
  className = '',
  children,
  type = 'button',
  ...rest
}: ButtonProps) => {
  const classes = [
    styles.button,
    styles[variant],
    block && styles.block,
    className
  ].filter(Boolean).join(' ')

  return (
    <button type={type} className={classes} {...rest}>
      {children}
    </button>
  )
}
